<template>
  <div>
    <div
      class="bg-[url('https://storage.googleapis.com/xurya-app-files/onm-suite-web/background/solar-panel.png')] bg-no-repeat bg-cover w-full h-full absolute"
    />
    <div class="absolute bg-black w-full h-full z-[2] opacity-40" />
    <div class="absolute w-full h-full z-[3] overflow-y-auto bg-black/60 ">
      <slot />
    </div>
  </div>
</template>
